import { render, staticRenderFns } from "./index-ad.vue?vue&type=template&id=6ebda674&scoped=true&ref=indexAd&"
import script from "./index-ad.vue?vue&type=script&lang=js&"
export * from "./index-ad.vue?vue&type=script&lang=js&"
import style0 from "./index-ad.vue?vue&type=style&index=0&id=6ebda674&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebda674",
  null
  
)

export default component.exports